import { render } from "./sortbyFilterBlock.vue?vue&type=template&id=45ff7252"
import script from "./sortbyFilterBlock.vue?vue&type=script&lang=js"
export * from "./sortbyFilterBlock.vue?vue&type=script&lang=js"

import "./sortbyFilterBlock.vue?vue&type=style&index=0&id=45ff7252&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__